import React, { useEffect, useState } from "react";
import "../styles/FloatingMessage.css";

interface FloatingMessageProps {
  text?: string;
  type?: "info" | "success" | "error" | "warning";
  show?: boolean;
  duration?: number;
  onClose?: () => void;
}

export default function FloatingMessage({
  text = "Hello, Ant Design!",
  type = "info",
  show = true,
  duration = 3000,
  onClose,
}: FloatingMessageProps) {
  const [visible, setVisible] = useState(show);

  useEffect(() => {
    if (show) {
      setVisible(true);
      if (duration > 0) {
        const timer = setTimeout(() => {
          setVisible(false);
          onClose && onClose();
        }, duration);
        return () => clearTimeout(timer);
      }
    }
  }, [show, duration, onClose]);

  if (!visible) return null;

  return (
    <div className={`floating-message ${type}`}>
      <span className="icon">
        {type === "success" && "✅"}
        {type === "error" && "❌"}
        {type === "warning" && "⚠️"}
        {type === "info" && "ℹ️"}
      </span>
      <span className="text">{text}</span>
    </div>
  );
}
